<div class="satır üst">
  <div class="sütun-12 sütun-k-12 boşlukYok">
    <h1><a id="başlık" href="/"> kelime</a> </h1>
  </div>
</div>

